// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/store'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css';
import * as echarts from 'echarts'
import comm from "./utils/common";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$echarts = echarts
Vue.prototype.$store = store

Vue.prototype.$A = comm;  //通用工具方法
Vue.use(Vant)
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
const wx = new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    render :h => h(App),
    // template: '<App/>',
}).$mount("#app")

export default wx;



// WEBPACK FOOTER //
// ./src/main.js